<template>
  <div>
    <el-carousel :height="imgWidth*0.333 + 'px'">
      <el-carousel-item v-for="(item,index) in imgs" :key="index">
        <img :src="item.image" alt style="width:100%;height:100%;" />
      </el-carousel-item>
    </el-carousel>
    <div class="lunbo_title">电测 计量 检定 校验</div>
    <div id="main">
      <div class="main_title">
        <div class="line"></div>
        <div style="font-family:SimHei;font-size:22px;">
          产品中心>>>
          <router-link to="/">
            <img class="back_to_index" src="../../assets/images/back_to_index.png" alt />
          </router-link>
        </div>

        <div style="font-family:SimHei;font-size:16px;margin-top:20px;">
          <router-link :to="{path:'/productDetail',query:{id:33}}">最新推出</router-link>>
          <!-- style="color:#3f33c0;" -->
          <!-- <router-link>军品系列</router-link>> -->
          <router-link :to="{path:'/productDetail',query:{id:9}}">交直流标准源系列</router-link>>
          <router-link :to="{path:'/productDetail',query:{id:16}}">铁路计量专用系列</router-link>>
          <router-link :to="{path:'/productDetail',query:{id:18}}">多功能标准表系列</router-link>>
          <router-link :to="{path:'/productDetail',query:{id:21}}">交直流电测仪表校验台系列</router-link>>
          <router-link :to="{path:'/productDetail',query:{id:25}}">交直流检定装置系列</router-link>>
          <router-link :to="{path:'/productDetail',query:{id:30}}">多功能现场校验仪系列</router-link>
        </div>
      </div>

      <div class="goods">
        <div class="goods_item" v-for="(item,index) in product_data" :key="item.id">
          <div class="goods_item_left">
            <div style="height:50px;width:100%;"></div>

            <div>
              <el-carousel v-if="index == 0|| index == 1" indicator-position="none" height="200px">
                <el-carousel-item v-for="item_img in item.images" :key="item_img.id">
                  <el-image style="width:100%;height:100%;" :src="item_img" fit="scale-down" alt></el-image>
                </el-carousel-item>
              </el-carousel>

              <el-image
                v-for="item_img in item.images"
                :key="item_img.id"
                v-if="index != 0 || index != 1"
                style="width:100%;height:100%;"
                :src="item_img"
                fit="scale-down"
                alt
              ></el-image>
            </div>
          </div>
          <div class="goods_item_right">
            <div class="goods_item_right_title">{{item.name}}</div>
            <ul class="goods_item_right_ul">
              <router-link
                v-if="index != 1"
                class="goods_item_right_li"
                v-for="item_li in item.product"
                :key="item_li.id"
                :to="{path:'/productDetail',query:{id:item_li.id}}"
              >
                <div class="point"></div>
                {{item_li.name}}
              </router-link>

              <li
                class="goods_item_right_li"
                v-if="index == 1"
                v-for="item_li in item.product"
                :key="item_li.id"
              >
                <div class="point"></div>
                {{item_li.name}}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in bottom_imgs" :key="index">
            <div>
              <img class="img" :src="item.image" alt fit="scale-down" />
              <!-- <el-image class="img" :src="item.image" alt fit="scale-down"></el-image> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
export default {
  data: function () {
    return {
      imgWidth: "",
      bottom_imgs: [], // 底部轮播图
      product_data: [], // 产品数据
      imgs: [],
    };
  },
  created: function () {
    setTimeout(function () {
      $(".lunbo_title").css({ transform: "scale(1)", transition: "2s" });
    }, 1000);
    setTimeout(function () {
      $(".lunbo_title").css({ transform: "scale(0)", transition: "2s" });
    }, 3000);
    setInterval(() => {
      setTimeout(function () {
        $(".lunbo_title").css({ transform: "scale(1)", transition: "2s" });
      }, 1000);
      setTimeout(function () {
        $(".lunbo_title").css({ transform: "scale(0)", transition: "2s" });
      }, 3000);
    }, 5000);
    // 获取轮播图数据
    this.$fetch("index/getAdList", { slot_id: 1 }).then((res) => {
      if (res.code == 1) {
        // console.log(res);
        this.imgs = res.data;
      } else {
        alert("请求出错，请稍后再试");
      }
    });
    this.imgWidth = document.body.clientWidth;
    this.$fetch("index/getBottomPic", { cate_id: 1 }).then((res) => {
      // 获取底部部分轮播
      // console.log(res);
      if (res.code == 1) {
        this.bottom_imgs = res.data;
      } else {
        alert("请求出错，请稍后再试");
      }
    });

    // 获取产品数据
    this.$fetch("Product/index").then((res) => {
      if (res.code == 1) {
        // console.log(res);
        this.product_data = res.data;
      } else {
        alert("请求出错了，请稍后再试");
      }
    });
  },
  updated: function () {
    var mySwiper = new Swiper(".swiper-container", {
      loop: true,
      autoplay: 3000,
      speed: 500,
      slidesPerView: "auto",
      observer: true,
      observeParents: true,
    });
  },
};
</script>
<style scoped>
.lunbo_title {
  position: absolute;
  color: #fff;
  font-size: 54px;
  font-family: SimHei;
  font-weight: bold;
  top: 250px;
  left: 34%;
  z-index: 10;
  transform: scale(0);
}
.main_title {
  width: 100%;
  height: 24px;
  margin-top: 40px;
  font-size: 20px;
}
.line {
  background-color: #2569e6;
  width: 3px;
  height: 100%;
  float: left;
  margin-right: 20px;
}
.goods {
  width: 100%;
  margin: 60px 0;
}
.goods_item {
  width: 47%;
  height: 300px;
  display: inline-block;
  margin-right: 4%;
  margin-bottom: 40px;
}
.goods_item:nth-child(2n) {
  margin-right: 0;
}
.goods_item .goods_item_left {
  width: 220px;
  height: 300px;
  background-color: #edf0f7;
  border-radius: 20px;
  float: left;
}
.goods_item .goods_item_left div {
  width: 100%;
  height: 200px;
  overflow-y: hidden;
}
.goods_item .goods_item_right {
  overflow-y: scroll;
  float: right;
  width: 320px;
  /* background-color: aqua; */
  height: 100%;
}
.goods_item .goods_item_right .goods_item_right_title {
  font-family: SimHei;
  font-size: 20px;
  margin-bottom: 10px;
}
.goods_item .goods_item_right .goods_item_right_ul {
  padding: 0 10px;
}
.goods_item .goods_item_right .goods_item_right_ul .goods_item_right_li {
  width: 100%;
  display: inline-block;
  border-bottom: 1px solid #e8e8e8;
  line-height: 30px;
}
.goods_item
  .goods_item_right
  .goods_item_right_ul
  .goods_item_right_li:first-child {
  border-top: 1px solid #e8e8e8;
}
.point {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #0e05d0;
  float: left;
  margin: 13px 10px 0 0;
}
.img_lunbo {
  margin-bottom: 40px;
  width: 100%;
  overflow: hidden;
}
.img_list {
  /* padding: 20px 0;
  border-top: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8; */
  width: 1000%;
  height: 170px;
  margin-left: -240px;
}
.img_list li {
  padding: 20px;
  background-color: #e8e8e8;
  float: left;
  border-radius: 30px;
  width: 180px;
  height: 130px;
  margin-right: 20px;
}
.img_list li:last-child {
  margin-right: 0;
}
.img_list li img {
  width: 180px;
  height: 90px;
  margin-top: 25px;
}
.imgDiv img:nth-child(4n) {
  margin-right: 0;
}
.swiper-slide div {
  padding: 20px 20px;
}
.swiper-slide div .img {
  height: 120px;
}
</style>


// WEBPACK FOOTER //
// src/components/productCenter/productCenter.vue